module.exports = __webpack_public_path__ + "static/media/wrs1.png.490a11d1.jpg";